module.exports = __webpack_public_path__ + "img/Seller-icon.443816e8.svg";